export default __webpack_public_path__ + "static/section-image-1-bac55ec56a51bc95412c55ffd8df43fd.jpg";